<div
	class="z-app-nav"
	id="app-nav"
	[ngClass]="{
		'bg-standard shadow-around outline outline-1 -outline-offset-1 outline-secondary-200 h-screen fixed w-80.5':
			open(),
	}"
>
	<button
		class="flex items-center hover:bg-primary-300 flex-col cursor-pointer h-14.5 justify-center my-3.5 w-17 focus-visible-border border-2 border-transparent focus:outline-none"
		(click)="toggle($event)"
		[ngClass]="{ 'bg-transparent! -mb-4!': open() }"
		data-cy="app-nav"
	>
		<ui-icon
			icon="menu_bento"
			size="l"
			[type]="open() ? 'dark' : navColor()"
			[ngClass]="{ 'mb-3.75': open() }"
		></ui-icon>
		@if (!open()) {
			<div
				class="text-secondary-800 text-[0.625rem]"
				[ngClass]="{
					'text-secondary-800': navColor() === 'dark',
					'text-primary-700': navColor() === 'primary',
					'text-white': navColor() === 'light',
				}"
			>
				{{ navTranslations()?.apps }}
			</div>
		}
	</button>
	@if (open()) {
		<div class="mx-12 mt-8">
			<a
				class="flex cursor-pointer justify-center mb-8 pb-3 pt-3 focus-visible-border border-2 border-transparent focus:outline-none"
				[href]="myApp().url || '#'"
				[target]="myApp().newTab ? '_blank' : '_self'"
				(mouseenter)="setHoveredApp(myApp())"
				(mouseleave)="setHoveredApp(undefined)"
				[style.background-color]="myApp() | appBackground: hoveredApp() : activeApp()"
			>
				<ng-container>
					<img alt="logo-my" class="h-16 w-48 block dark:hidden" [src]="myApp().image" />
					<img alt="logo-my" class="h-16 w-48 hidden dark:block" [src]="myApp().darkImage" />
				</ng-container>
			</a>
			<div class="mb-8">
				<ui-divider></ui-divider>
			</div>
			@for (app of _apps(); track app.name) {
				<a
					class="cursor-pointer flex gap-2 pb-3 pl-4 pt-3 focus-visible-border border-2 border-transparent focus:outline-none"
					[href]="app.url || '#'"
					[target]="app.newTab ? '_blank' : '_self'"
					[attr.data-cy]="'app-nav-' + app.name"
					[style.background-color]="app | appBackground: hoveredApp() : activeApp()"
					(mouseenter)="setHoveredApp(app)"
					(mouseleave)="setHoveredApp(undefined)"
				>
					<img
						[alt]="'logo-' + app.name"
						[src]="app.image"
						class="max-h-12 max-w-[11.8rem] block dark:hidden"
					/>
					<img
						[alt]="'logo-' + app.name"
						[src]="app.darkImage"
						class="max-h-12 max-w-[11.8rem] hidden dark:block"
					/>

					@if (app.beta) {
						<ui-tag [text]="navTranslations()?.beta || ''" type="dark" class="block mt-1"></ui-tag>
					}
				</a>
			}
		</div>
	}
</div>
